import { getNewUsedState } from 'site-modules/shared/utils/new-used-state';
import { isUsedUsedPubState } from 'site-modules/shared/utils/core-page/is-used-pub-state';
import { isPreProd } from 'site-modules/shared/utils/publication-states';
import { getLastWordPlural } from 'client/utils/plural';
import { BODY_TYPE_SLUGS } from 'site-modules/shared/constants/upper-funnel/car-types';
import { getBreadcrumbName } from 'site-modules/shared/utils/upper-funnel/type-mapping';

/**
 * submodelName includes model name example: Accord Sedan
 * so we replace a model name with an empty string to get a submodel name
 * unless the submodelName is the same as the model name in order to
 * avoid returning an empty string.
 *
 * @param {String} submodelName
 * @param {String} modelName
 * @return {String}
 */
export function getSubmodelIdentifier(submodelName, modelName) {
  if (!submodelName || submodelName === modelName) {
    return submodelName;
  }

  return submodelName.replace(modelName, '').trim();
}

export function getBodyTypeBreadcrumbFromCategories(edmundsTypeCategories) {
  const typeSlug = Object.keys(edmundsTypeCategories || {}).find(slug => BODY_TYPE_SLUGS.has(slug));

  if (!typeSlug) {
    return null;
  }

  const breadcrumbName = getBreadcrumbName(typeSlug);

  return {
    title: getLastWordPlural(breadcrumbName),
    href: `/${typeSlug}/`,
  };
}

/**
 * Clone params object and extends with isUsed and isNewUsed property.
 *
 * @param {Object} router
 * @param {String} year
 * @param {boolean} isUsed
 * @returns {Object}
 */
export function cloneParamsWithPubState({ params, year, isUsed }) {
  const isNewUsed = getNewUsedState(isUsed, year);
  const isUsedUsed = isUsedUsedPubState(year);

  return {
    isUsed,
    isNewUsed,
    isUsedUsed,
    ...params,
    year,
  };
}

export function getPublicationStateKey(pubStates, isUsed) {
  if (isPreProd(pubStates)) {
    return 'preprod';
  }

  return isUsed ? 'used' : 'new';
}
